import type { GitHubPosition } from "../../app/services/github";

export const POSITION_OPTIONS: { id: GitHubPosition; name: string }[] = [
  { id: "CLIENT", name: "クライアント" },
  { id: "REVIEWER", name: "レビュアー" },
  { id: "PRODUCER", name: "プロデューサー" },
  { id: "DIRECTOR", name: "ディレクター" },
  { id: "SPECIALIST", name: "スペシャリスト" },
];

export const POSITION_LABELS: Record<string, string> = Object.fromEntries(
  POSITION_OPTIONS.map((p) => [p.id, p.name]),
);
